import type {
  SubscriptionPlanFeaturesT,
  UserPresentationRole,
} from '@mentimeter/http-clients';

export type UpgradeButtonTrackingPlacement =
  | 'Engagement limits banner'
  | 'Header user actions'
  | 'Footer actions'
  | 'Header actions'
  | 'Invite view - collaboration';

export interface PaywallSeriesTrackingProperties {
  role: UserPresentationRole;
  'presentation owner': boolean;
  'shared presentation': boolean;
}

export interface QuestionModuleTrackingProperties {
  role: string | null;
  'presentation owner': boolean;
  'shared presentation': boolean;
  'active team members': number;
  'current plan': SubscriptionPlanFeaturesT;
  'role in workspace': string;
}

export type TrackingProperties =
  | PaywallSeriesTrackingProperties
  | QuestionModuleTrackingProperties
  | undefined;

export type UpgradeEvent = 'Plans from homeview' | 'Plans from editor';

export type AccessLevel = 'not-in-plan' | 'not-in-role' | 'has-access';

export type NoAccess = Extract<AccessLevel, 'not-in-plan' | 'not-in-role'>;

export type PaywallType = 'Classic' | 'Recommend plan';

export enum UpgradeType {
  SELF_UPGRADE = 'Self upgrade',
  REQUEST_UPGRADE = 'Request upgrade',
}
